import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { queryStatement } from "./services";
import { USE_MOCK, MOCK_STATEMENT } from "./mock";

// TODO: 联调期 mock，看完页面改回真实请求（删掉 mock 分支，恢复 queryStatement()）
export function statementLoader() {
  return defer({
    coreData: resolveLoaderResult(queryStatement()),
    // coreData: resolveLoaderResult(
    //   new Promise((resolve) => {
    //     setTimeout(() => {
    //       resolve(MOCK_STATEMENT);
    //     }, 2000);
    //   }),
    // ),
  });
}
